import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, resolveDynamicComponent as _resolveDynamicComponent, createElementVNode as _createElementVNode, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "chat-trigger" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Message = _resolveComponent("Message")!
  const _component_Button = _resolveComponent("Button")!
  const _component_GradientList = _resolveComponent("GradientList")!

  return (_openBlock(), _createElementBlock("footer", null, [
    _createElementVNode("div", _hoisted_1, [
      (!_ctx.isChatOpen)
        ? (_openBlock(), _createBlock(_component_Button, {
            key: 0,
            type: "primary",
            style: {"width":"44px"},
            onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.isChatOpen = true))
          }, {
            default: _withCtx(() => [
              _createVNode(_component_Message)
            ]),
            _: 1
          }))
        : _createCommentVNode("", true),
      (_openBlock(), _createBlock(_resolveDynamicComponent(_ctx.chat.component), {
        "is-open": _ctx.isChatOpen,
        onClose: _cache[1] || (_cache[1] = ($event: any) => (_ctx.isChatOpen = false))
      }, null, 40, ["is-open"]))
    ]),
    _createVNode(_component_GradientList)
  ]))
}